module.exports = __webpack_public_path__ + "img/awards.74cda228.svg";